import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useFlags } from "launchdarkly-react-client-sdk";
import isNil from "lodash/isNil";
import { memo, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DiscussionForm } from "~/components/Discussions/DiscussionForm";
import { NewDiscussionActions } from "~/components/Discussions/InitialCommentInput/components/NewDiscussionActions";
import { ADD_DISCUSSION_COMMENT_INPUT } from "~/constants/testIDs";
import { useNoPreviewInVisualizer } from "~/hooks/useNoPreviewInVisualizer";
import { useAnnotationContextSelector } from "~/providers/AnnotationProvider/AnnotationProvider";
import { newAnnotationInfoSelector } from "~/providers/AnnotationProvider/annotationProviderUtils";
import { useVideoTimestampContext } from "~/providers/VideoTimestampProvider";
import { centralizedClipStatusSelector } from "~/store/centralizedClip/selectors";
import { activeTimestampParamSelector } from "~/store/router/selectors";
import { isMobileAgent } from "~/utils/PlatformHelpers";
export const InitialCommentInput = /*#__PURE__*/ memo((param)=>{
    let { comment, hasCancelButton, mentionsList, onSubmit, onCancel, placeholder, shouldShowMentionsButton, hasInternalAvatar, canAnnotateClip } = param;
    const { videoTimestamp: hasVideoTimestampFlag } = useFlags();
    const { isAboveMediumScreen } = useBreakpointsContext();
    const activeTimestamp = useSelector(activeTimestampParamSelector);
    const { currentTime } = useVideoTimestampContext();
    const clipStatus = useSelector(centralizedClipStatusSelector);
    const newAnnotation = useAnnotationContextSelector(newAnnotationInfoSelector);
    const [shouldEnableTimestamps, setShouldEnableTimestamps] = useState(false);
    const isDesktop = isAboveMediumScreen && !isMobileAgent;
    const { noPreviewInVisualizer } = useNoPreviewInVisualizer();
    useEffect(()=>{
        if (hasVideoTimestampFlag) {
            setShouldEnableTimestamps(true);
        }
    }, [
        hasVideoTimestampFlag
    ]);
    useEffect(()=>{
        if (!hasVideoTimestampFlag) {
            setShouldEnableTimestamps(!!newAnnotation);
        }
    }, [
        hasVideoTimestampFlag,
        newAnnotation
    ]);
    useEffect(()=>{
        if (activeTimestamp) {
            setShouldEnableTimestamps(hasVideoTimestampFlag || !isNil(activeTimestamp));
        }
    }, [
        activeTimestamp,
        clipStatus,
        hasVideoTimestampFlag
    ]);
    const handleCommentSubmit = useCallback((comment)=>{
        onSubmit(comment, isDesktop && shouldEnableTimestamps ? hasVideoTimestampFlag ? currentTime : activeTimestamp : undefined);
    }, [
        activeTimestamp,
        hasVideoTimestampFlag,
        isDesktop,
        onSubmit,
        shouldEnableTimestamps,
        currentTime
    ]);
    return /*#__PURE__*/ _jsx(DiscussionForm, {
        "data-testid": ADD_DISCUSSION_COMMENT_INPUT,
        comment: comment,
        hasCancelButton: hasCancelButton,
        mentionsList: mentionsList,
        onCancel: onCancel,
        onSubmit: handleCommentSubmit,
        placeholder: placeholder,
        shouldShowMentionsButton: shouldShowMentionsButton,
        hasInternalAvatar: hasInternalAvatar,
        leftActions: /*#__PURE__*/ _jsx(NewDiscussionActions, {
            canAnnotateClip: canAnnotateClip,
            shouldEnableTimestamps: shouldEnableTimestamps,
            setShouldEnableTimestamps: setShouldEnableTimestamps,
            shouldDisableTimestampsAndAnnotations: noPreviewInVisualizer
        })
    });
});
InitialCommentInput.displayName = "InitialCommentInput";
